import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { useCallback } from 'react';

import type { Location, MinimalOrganization } from '@/types';

const PRO_ORGANIZATIONS_QUERY_KEY = ['internal_api', 'pro', 'organizations'] as const;

export type InternalPractitioner = { id: string; display_name: string };

export type OrganizationGroups = {
  my_organizations: (MinimalOrganization & {
    paywalled: boolean;
    locations: Location[];
    practitioners: InternalPractitioner[];
  })[];
  external_organizations: MinimalOrganization[];
};

export const useOrganizationsIndex = () =>
  useQuery({
    queryKey: PRO_ORGANIZATIONS_QUERY_KEY,
    queryFn: async () => {
      const { data } = await axios.get<OrganizationGroups>('/internal_api/pro/organizations');
      if (!Array.isArray(data?.my_organizations) || !Array.isArray(data?.external_organizations)) {
        throw new AxiosError('Invalid organizations response', AxiosError.ERR_BAD_RESPONSE);
      }
      return data;
    },
  });

export const useInvalidateOrganizations = () => {
  const queryClient = useQueryClient();
  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: PRO_ORGANIZATIONS_QUERY_KEY }),
    [queryClient],
  );

  return { invalidate };
};
